import React, { useEffect, useState } from "react";
import {
  FREQUENCY_OPTIONS,
  WEEKDAYS,
  buildCronExpression,
  parseCronExpression,
} from "./cronExpression";

// Friendly "every day/week/month at HH:MM" picker that outputs a raw cron
// expression via onChange(cronExpression). Falls back to a raw-text field
// when the frequency is "custom" or the incoming expression can't be
// reverse-parsed (e.g. someone hand-wrote something more complex).
const ScheduleBuilder = ({ value, onChange }) => {
  const parsed = parseCronExpression(value);
  const [frequency, setFrequency] = useState(
    parsed?.frequency || (value ? "custom" : "daily"),
  );
  const [time, setTime] = useState(parsed?.time || "09:00");
  const [daysOfWeek, setDaysOfWeek] = useState(parsed?.daysOfWeek || []);
  const [dayOfMonth, setDayOfMonth] = useState(parsed?.dayOfMonth || 1);
  const [customExpression, setCustomExpression] = useState(
    parsed ? "" : value || "",
  );

  useEffect(() => {
    if (frequency === "custom") {
      onChange(customExpression);
    } else {
      onChange(
        buildCronExpression({ frequency, time, daysOfWeek, dayOfMonth }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [frequency, time, daysOfWeek, dayOfMonth, customExpression]);

  const toggleDay = (day) =>
    setDaysOfWeek((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day],
    );

  return (
    <div className="schedule-builder">
      <div className="form-grid">
        <label className="form-field">
          <span>Repeats</span>
          <select
            value={frequency}
            onChange={(e) => setFrequency(e.target.value)}
          >
            {FREQUENCY_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </label>

        {frequency !== "custom" && (
          <label className="form-field">
            <span>At</span>
            <input
              type="time"
              value={time}
              onChange={(e) => setTime(e.target.value)}
            />
          </label>
        )}

        {frequency === "monthly" && (
          <label className="form-field">
            <span>Day of month</span>
            <input
              type="number"
              min={1}
              max={31}
              value={dayOfMonth}
              onChange={(e) => setDayOfMonth(Number(e.target.value))}
            />
          </label>
        )}
      </div>

      {frequency === "weekly" && (
        <div className="weekday-picker">
          {WEEKDAYS.map((day) => (
            <button
              key={day.value}
              type="button"
              className={`weekday-pill ${daysOfWeek.includes(day.value) ? "weekday-pill--active" : ""}`}
              onClick={() => toggleDay(day.value)}
            >
              {day.label}
            </button>
          ))}
        </div>
      )}

      {frequency === "custom" && (
        <label className="form-field form-field--full">
          <span>Cron expression</span>
          <input
            type="text"
            placeholder="0 0 9 * * *"
            value={customExpression}
            onChange={(e) => setCustomExpression(e.target.value)}
          />
          <small>
            Format: second minute hour day-of-month month day-of-week.
          </small>
        </label>
      )}
    </div>
  );
};

export default ScheduleBuilder;
